import {Button, Grid, makeStyles} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {moveNextPage, updateCreatorOnboarding} from "../../../../../store/actions/creator/creatorOnBoarding";
import {BackDropAnalyzeLoading} from '../../../../atoms/commonLoadings';
import {createExperience} from "../../../../../store/actions";
import UtilService from "../../../../../helper/service";
import {useHistory, useLocation} from "react-router";
import CustomSnackBar from "../../experienceManager/participantsDashboard/component/CustomSnackBar";

const useStyles = makeStyles(() => ({
  pageTitle: {
    textAlign: 'center',
    fontSize: 36,
    color: '#212D40',
    fontFamily: 'Spartan-bold',
    lineHeight: 1.25,
    marginTop: 30,
    '@media (max-width: 600px)': {
      fontSize: '25px!important',
    },
  },
  title: {
    fontSize: (props: any) => props.height < 770 ? 30 : 42,
    color: '#212D40',
    fontFamily: 'Spartan-bold',
    lineHeight: 1.25,
    marginTop: 20,
    '@media (max-width: 600px)': {
      fontSize: '25px!important',
    },
  },
  subTitle: {
    fontSize: (props: any) => props.height < 770 ? 24 : 30,
    color: '#212D40',
    fontFamily: 'roboto-light',
    marginTop: 15,
    marginBottom: 15,
    '@media (max-width: 600px)': {
      fontSize: '15px!important',
    },
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    cursor: 'pointer',
    maxWidth: 'calc(50% - 20px)',
    margin: '0 10px'
  },
  card: {
    borderRadius: 10,
    backgroundColor: "#f0f0f0",
    boxShadow: '1px 1px 1px 1px #f0f0f0',
    padding: 20,
    marginTop: 10
  },
  imgDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  img: {
    height: (props: any) => props.height < 770 ? 140 : 160,
    width: 'auto',
    borderRadius: 10
  },
  addNewBtn: {
    fontFamily: 'roboto-regular',
    fontSize: 20,
    marginLeft: 5,
    marginRight: 5,
    '@media (max-width: 600px)': {
      fontSize: 11,
    },
  },
  btn: {
    borderRadius: 6,
    padding: '10px 25px 10px 25px',
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    '@media (max-width: 600px)': {
      padding: '3px 12px',
    },
  },
  description: {
    fontFamily: 'roboto-light',
    fontSize: 24,
    color: '#212D40',
    lineHeight: 1.25,
    '@media (max-width: 600px)': {
      fontSize: '15px!important',
    },
  }
}));

const Module2Slide2 = () => {

  const size = UtilService.useWindowSize();
  const classes = useStyles(size);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const { userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { pickvideoinfo, activepage } = userPreferences;
  const [loading, setLoading] = useState(false);
  const [asyncExperienceName, setAsyncExperienceName] = useState('');
  const [asyncFileName, setAsyncFileName] = useState('');
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'm2s2');
  }, []);

  useEffect(() => {
    if (pickvideoinfo && pickvideoinfo.id) {
      const information = JSON.parse(pickvideoinfo.value);
      setAsyncExperienceName(information['asyncExperienceName']);
      setAsyncFileName(information['asyncFileName'])
    }
  }, [pickvideoinfo]);

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13) {
      goNext();
    }
  };

  const goNext = () => {
    setLoading(true);
    const videoInfo = JSON.parse(pickvideoinfo.value);

    let startDateTime, endDateTime;
    if (videoInfo['braintrust'] && videoInfo['braintrust']['braintrust_id']) {
      startDateTime = UtilService.getAsyncAddminuite();
      endDateTime = UtilService.getDateAddseconds(startDateTime, 360)
    } else {
      startDateTime = UtilService.getXHoursAboveDateTime(new Date(), 1 / 60);
      endDateTime = UtilService.getXHoursAboveDateTime(startDateTime, 24);
    }

    const request = {
      title: videoInfo['asyncExperienceName'],
      description: '',
      scheduled_start: startDateTime,
      scheduled_end: endDateTime,
      user_id: loginUserData.user_id,
      status: 'UPCOMING',
      type: 'ASYNC',
      session_code: videoInfo['sessionCode'],
      subcategory: videoInfo['item'],
      category: videoInfo['content'],
      participants: [],
      braintrust_id: videoInfo['braintrust'] && videoInfo['braintrust']['braintrust_id'] ? videoInfo['braintrust']['braintrust_id'] : "",
      braintrust_demo: !!(videoInfo['braintrust'] && videoInfo['braintrust']['sample_video_link'])
    };
    dispatch(createExperience(apolloClient.client, request, (res: any) => {
      if (res) {
        if (Number(activepage.value) < 11) {
          const reqActivePage = {
            user_id: loginUserData.user_id,
            preference_id: userPreferences.activepage.id,
            preference_name: 'ACTIVEPAGE',
            preference_information: '11',
          };
          dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));
        }

        dispatch(moveNextPage(11));
      } else {
        setLoading(false);
        setShowAlert(true);
      }
    }))
  };

  return (
    <div>
      <Grid container >
        <Grid item lg={9} md={12} sm={12} container className={classes.card}>
          <Grid item lg={6} md={5} sm={5} className={classes.imgDiv}>
            <img src={asyncFileName} className={classes.img} />
          </Grid>
          <Grid item lg={6} md={7} sm={7}>
            <div className={classes.subTitle}>You’re Measuring:</div>
            <div className={classes.title}>{asyncExperienceName}</div>
          </Grid>
        </Grid>
        <Grid item lg={12} md={12} sm={12} container>
          <div className={classes.pageTitle}>
            Normally, you would invite participants, but...
          </div>
          <div className={classes.description}>
            <p>For this measurement, we’ll automatically send this sample video out to a group of volunteer participants to watch on their own schedules.</p>
            <p>For future measurements, you’ll be in charge of inviting your own participants. If you need access to an audience you can measure, we have solutions to assist you.</p>
          </div>
        </Grid>
        <Grid item container justifyContent='center' style={{ position: 'relative' }}>
          <Button
            color='primary'
            className={classes.btn}
            onClick={goNext}
          >
            <span className={classes.addNewBtn}>Send Video For Measurement</span>
          </Button>
        </Grid>
      </Grid>
      <BackDropAnalyzeLoading loading={loading} />
      <CustomSnackBar
        type={'error'}
        message={'Sending Video for Measurement failed'}
        open={showAlert}
        onClose={() => setShowAlert(false)}
      />
    </div>
  )
};

export default Module2Slide2;